import { styled } from "@mui/system";
import {
  DISPLAY_FLEX,
  FLEX_DIRECTION_ROW,
  FLEX_DIRECTION_COLUMN,
  FLEX_ALIGN_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_NORMAL,
  FONT_SIZE_SM,
  FONT_SIZE_MD,
  FONT_SIZE_LG,
  FONT_SIZE_XXL,
  LINE_HEIGHT_SM,
  LINE_HEIGHT_MD,
  BORDER_RADIUS_SM,
  BORDER_RADIUS_MD,
  BORDER_RADIUS_LG,
  FONT_SIZE_CUSTOM_LG,
} from "../../config/styles";
import { colors } from "../../config/colors";
import { Modal, Button } from "react-bootstrap";

export const CancelMandateButton = styled(Button)(({ disabled }) => ({
  display: DISPLAY_FLEX,
  height: "36px",
  padding: "8px 12px",
  justifyContent: "center",
  alignItems: FLEX_ALIGN_CENTER,
  gap: "8px",
  borderRadius: BORDER_RADIUS_SM,
  border: "none !important",
  background: `${disabled ? colors.disabled : colors.warning} !important`,
  color: `${colors.white} !important`,
  fontSize: FONT_SIZE_MD,
  fontFamily: "Open Sans, sans-serif",
  fontWeight: FONT_WEIGHT_MEDIUM,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? colors.disabledOpacity + 0.1 : 1,
  transition: "all 0.2s",
  "&:hover": {
    background: `${disabled ? colors.disabled : colors.warningHover} !important`,
    color: `${colors.white} !important`,
  },
  "&:focus": {
    boxShadow: "none",
    background: `${disabled ? colors.disabled : colors.warning} !important`,
  },
  "&:active": {
    background: `${disabled ? colors.disabled : colors.warningHover} !important`,
  },
}));

export const DirectDebitStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  padding: "0px 40px",
  marginLeft: "256px",
  backgroundColor: theme.palette.secondary.contrastText,
  borderRadius: "12px 0px",
  minHeight: "calc(100vh - 100px)",
}));

export const SkeletonWrapper = styled("div")(() => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  gap: "2px",
}));

export const DirectDebitListStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  gap: "16px",
  width: "100%",
  "& .toolbar": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    alignItems: FLEX_ALIGN_CENTER,
    alignSelf: "stretch",
  },
  "& .search-filters": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    gap: "8px",
  },
  "& .search-input-wrapper": {
    position: "relative",
    display: DISPLAY_FLEX,
    width: "380px",
    alignItems: FLEX_ALIGN_CENTER,
  },
  "& .search-input": {
    display: DISPLAY_FLEX,
    height: "36px",
    width: "100%",
    padding: "8px 12px",
    paddingRight: "40px",
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    alignItems: FLEX_ALIGN_CENTER,
    alignSelf: "stretch",
    borderRadius: BORDER_RADIUS_SM,
    border: `1px solid ${colors.grayBackground}`,
    background: colors.surface,
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    color: colors.nonActive,
    outline: "none",
    "&::placeholder": {
      color: colors.nonActive,
    },
    "&:focus": {
      borderColor: colors.primary,
      color: "#000000",
    },
    "&:not(:placeholder-shown)": {
      color: "#000000",
    },
  },
  "& .search-icon": {
    position: "absolute",
    right: "12px",
    pointerEvents: "none",
  },
  "& .export-button": {
    display: DISPLAY_FLEX,
    height: "36px",
    padding: "8px 12px",
    justifyContent: "center",
    alignItems: FLEX_ALIGN_CENTER,
    gap: "8px",
    borderRadius: BORDER_RADIUS_SM,
    border: `1px solid ${colors.grayBackground}`,
    background: colors.surface,
    color: colors.custom,
    cursor: "pointer",
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: colors.background,
    },
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
  "& .toggled .label14": {
    color: "#000000 !important",
  },
  "& .toggledActive .label14": {
    color: "#000000 !important",
  },
  "& .toggled .dropdownTriangle": {
    filter: "brightness(0) !important",
  },
  "& .toggledActive .dropdownTriangle": {
    filter: "brightness(0) !important",
  },
  "& .ag-grid-container": {
    width: "100%",
    "& .ag-theme-material": {
      width: "100%",
      height: "600px",
      "--ag-pinned-column-border": "none",
    },
    "& .ag-root-wrapper": {
      border: `1px solid ${colors.storkeLight}`,
      borderRadius: BORDER_RADIUS_SM,
    },
    "& .ag-header": {
      backgroundColor: colors.background,
      borderBottom: `1px solid ${colors.storkeLight}`,
    },
    "& .ag-header-cell": {
      display: DISPLAY_FLEX,
      height: "42px",
      padding: "0 24px !important",
      alignItems: FLEX_ALIGN_CENTER,
      justifyContent: "flex-start",
      fontSize: `${FONT_SIZE_MD} !important`,
      fontFamily: "Open Sans, sans-serif",
      fontWeight: "500 !important",
      fontStyle: "normal",
      lineHeight: "18px !important",
      letterSpacing: "0 !important",
      color: `${colors.nonActive} !important`,
      overflow: "visible",
    },
    "& .ag-pinned-left-header": {
      borderRight: "none !important",
    },
    "& .ag-pinned-right-header": {
      borderLeft: "none !important",
    },
    "& .ag-header-cell-label": {
      overflow: "visible",
      textOverflow: "clip",
      whiteSpace: "nowrap",
      padding: "0 !important",
      margin: "0 !important",
      display: "flex",
      alignItems: "center",
    },
    "& .ag-header-cell-text": {
      textAlign: "left",
      overflow: "visible",
      textOverflow: "clip",
      whiteSpace: "nowrap",
    },
    "& .ag-row": {
      display: DISPLAY_FLEX,
      height: "52px",
      alignItems: FLEX_ALIGN_CENTER,
      cursor: "pointer",
      borderBottom: `1px solid ${colors.storkeLight} !important`,
      "&:last-child": {
        borderBottom: "none !important",
      },
      "&:hover": {
        backgroundColor: `${colors.hoverBackground} !important`,
      },
    },
    "& .ag-cell": {
      display: DISPLAY_FLEX,
      padding: "0 24px !important",
      alignItems: FLEX_ALIGN_CENTER,
      fontSize: `${FONT_SIZE_MD} !important`,
      fontFamily: "Open Sans, sans-serif",
      fontWeight: "400 !important",
      fontStyle: "normal",
      lineHeight: "18px !important",
      letterSpacing: "0 !important",
      color: `${colors.custom} !important`,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .ag-cell-last-left-pinned": {
      borderRight: "none !important",
    },
    "& .ag-cell-first-right-pinned": {
      borderLeft: "none !important",
    },
    "& .ag-cell.status-active": {
      color: colors.custom,
    },
    "& .ag-cell.status-cancelled": {
      color: colors.statusCancelled,
    },
    "& .ag-cell.status-completed": {
      color: colors.statusSuccess,
    },
    "& .ag-cell.status-success": {
      color: colors.statusSuccess,
    },
    "& .ag-cell.status-failed": {
      color: colors.warning,
    },
    "& .ag-cell.status-pending": {
      color: colors.statusPending,
    },
  },
  "& .status-badge": {
    padding: "4px 12px",
    borderRadius: BORDER_RADIUS_SM,
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    display: "inline-block",
    textAlign: "center",
  },
  "& .status-active": {
    color: colors.custom,
  },
  "& .status-cancelled": {
    color: colors.statusCancelled,
  },
  "& .status-completed": {
    color: colors.statusSuccess,
  },
  "& .status-success": {
    color: colors.statusSuccess,
  },
  "& .status-failed": {
    color: colors.warning,
  },
  "& .status-pending": {
    color: colors.statusPending,
  },
  "& .no-data-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: "center",
    padding: "60px 20px",
    color: colors.nonActive,
  },
}));

export const DirectDebitDetailsStyled = styled("div")(({ theme }) => ({
      display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  padding: "0px 40px",
  marginLeft: "256px",
  backgroundColor: theme.palette.secondary.contrastText,
  borderRadius: "12px 0px",
  minHeight: "calc(100vh - 100px)",
  "& .details-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "0",
  },

  "& .back-button": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: FONT_SIZE_LG,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_MEDIUM,
    color: colors.custom,
    padding: 0,
    "&:hover": {
      opacity: 0.8,
    },
  },

  "& .cancel-button": {
    display: "flex",
    height: "36px",
    padding: "8px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: BORDER_RADIUS_SM,
    border: "none",
    background: colors.warning,
    color: colors.white,
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: colors.warningHover,
    },
    "&:disabled": {
      background: colors.disabled,
      cursor: "not-allowed",
      opacity: colors.disabledOpacity + 0.1,
    },
  },

  "& .combined-section": {
    backgroundColor: colors.surface,
    borderRadius: BORDER_RADIUS_MD,
    border: `1px solid ${colors.storkeLight}`,
    overflow: "hidden",
  },

  "& .section-part": {
    padding: "24px",
    borderBottom: `1px solid ${colors.storkeLight}`,

    "&:last-child": {
      borderBottom: "none",
    },
  },

  "& .payment-section": {
    backgroundColor: colors.surface,
    borderRadius: BORDER_RADIUS_MD,
    border: `1px solid ${colors.storkeLight}`,
    padding: "0",
    marginTop:"16px",
    marginBottom:"14px",
    overflow: "hidden",

    "& .section-title": {
      fontSize: FONT_SIZE_LG,
      fontFamily: "Open Sans, sans-serif",
      fontWeight: FONT_WEIGHT_MEDIUM,
      lineHeight: LINE_HEIGHT_MD,
      color: colors.custom,
      marginBottom: "0",
      padding: "24px 24px 16px 24px",
    },
  },

  "& .section-title": {
    fontSize: FONT_SIZE_LG,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: LINE_HEIGHT_MD,
    color: colors.custom,
    marginBottom: "16px",
  },

  "& .section-header": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",

    "& .section-title": {
      margin: 0,
    },
  },

  "& .info-grid": {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "16px",
    "@media (max-width: 1400px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },

  "& .info-item": {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },

  "& .info-label": {
    fontSize: FONT_SIZE_SM,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: LINE_HEIGHT_SM,
    color: colors.nonActive,
  },

  "& .info-value": {
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    color: colors.custom,

    "&.status-active": {
      color: colors.statusSuccess,
    },
    "&.status-inactive": {
      color: colors.warning,
    },
    "&.status-success": {
      color: colors.statusSuccess,
    },
    "&.status-failed": {
      color: colors.warning,
    },
    "&.status-pending": {
      color: colors.statusPending,
    },
  },

  "& .ag-grid-container": {
    width: "100%",

    "& .ag-theme-material": {
      width: "100%",
    },

    "& .ag-root-wrapper": {
      border: "none",
      borderRadius: "0",
      borderTop: `1px solid ${colors.storkeLight}`,
    },

    "& .ag-header": {
      backgroundColor: colors.background,
      borderBottom: `1px solid ${colors.storkeLight}`,
    },

    "& .ag-header-cell": {
      display: "flex",
      height: "42px",
      padding: "0 24px !important",
      alignItems: "center",
      justifyContent: "flex-start",
      fontSize: `${FONT_SIZE_MD} !important`,
      fontFamily: "Open Sans, sans-serif",
      fontWeight: "500 !important",
      fontStyle: "normal",
      lineHeight: "18px !important",
      letterSpacing: "0 !important",
      color: `${colors.nonActive} !important`,
      overflow: "visible",
    },

    "& .ag-header-cell-label": {
      overflow: "visible",
      textOverflow: "clip",
      whiteSpace: "nowrap",
    },

    "& .ag-header-cell-text": {
      textAlign: "left",
      overflow: "visible",
      textOverflow: "clip",
      whiteSpace: "nowrap",
    },

    "& .ag-row": {
      display: "flex",
      height: "52px",
      alignItems: "center",
      borderBottom: `1px solid ${colors.storkeLight} !important`,
      "&:last-child": {
        borderBottom: "none !important",
      },
      "&:hover": {
        backgroundColor: `${colors.hoverBackground} !important`,
      },
    },

    "& .ag-cell": {
      display: "flex",
      alignItems: "center",
      padding: "0 24px !important",
      fontSize: `${FONT_SIZE_MD} !important`,
      fontFamily: "Open Sans, sans-serif",
      fontWeight: "400 !important",
      fontStyle: "normal",
      lineHeight: "18px !important",
      letterSpacing: "0 !important",
      color: `${colors.custom} !important`,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    "& .ag-cell-center": {
      justifyContent: "center !important",
      textAlign: "center !important",
      padding: "0 !important",
    },

    "& .ag-cell-center .ag-cell-wrapper": {
      justifyContent: "center !important",
      width: "100%",
      display: "flex",
    },

    "& .ag-cell-center .ag-react-container": {
      justifyContent: "center !important",
      width: "100%",
      display: "flex",
    },

    "& .ag-header-cell-center": {
      justifyContent: "center !important",
      textAlign: "center !important",
    },

    "& .edit-action-button": {
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto",
      transition: "opacity 0.2s",
      "&:hover": {
        opacity: 0.7,
      },
    },
  },
}));

export const CancelPlanModalStyled = styled(Modal)(({ theme }) => ({
  "& .modal-dialog": {
    maxWidth: "408px",
    margin: "1.75rem auto",
  },
  "& .modal-content": {
    borderRadius: BORDER_RADIUS_LG,
    border: "none",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    padding: 0,
    backgroundColor: colors.surface,
  },
  "& .modal-body": {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  "& .icon-container": {
    display: "flex",
    padding: "36px 10px 0 10px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
  },
  "& .info-icon": {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    backgroundColor: colors.primary,
    color: colors.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "32px",
    fontWeight: FONT_WEIGHT_BOLD,
  },
  "& .text-container": {
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    alignSelf: "stretch",
  },
  "& .modal-title": {
    fontSize: FONT_SIZE_XXL,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: "28px",
    letterSpacing: "-0.8px",
    color: colors.custom,
    textAlign: "center",
    alignSelf: "stretch",
    margin: 0,
  },
  "& .modal-message": {
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    color: colors.grayLight,
    textAlign: "center",
    alignSelf: "stretch",
    margin: 0,
  },
  "& .actions-container": {
    display: "flex",
    padding: "0 24px 24px 24px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    backgroundColor: colors.surface,
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
  "& .btn-secondary": {
    display: "flex",
    height: "36px",
    padding: "8px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
    borderRadius: BORDER_RADIUS_SM,
    border: `1px solid ${colors.grayBackground}`,
    backgroundColor: colors.surface,
    color: colors.custom,
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: colors.background,
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: colors.disabledOpacity + 0.1,
    },
  },
  "& .btn-danger": {
    display: "flex",
    height: "36px",
    padding: "8px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
    borderRadius: BORDER_RADIUS_SM,
    border: "none",
    backgroundColor: colors.warning,
    color: colors.white,
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: colors.warningHover,
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: colors.disabledOpacity + 0.1,
    },
  },
}));
